import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import Table from '@material-ui/core/Table'
import Tooltip from '@material-ui/core/Tooltip'
import {
  fetchSensorsData,
  setEnvironmentModule,
} from 'reducers/slaMonitor/environment/reducer'
import { toFixed } from 'helpers/math'
import {
  TYPE_SATURATION,
  TYPE_OXYGEN,
  TYPE_TEMPERATURE,
  TYPE_SPEED,
} from 'helpers/environmentMonitor'
import licenseeDigitFormat from 'helpers/licenseeDigitFormat'
import messages from '../../translate'

class ModuleB extends Component {
  componentDidMount() {
    const { activeSite, activeDate, fetchSensorsData } = this.props

    fetchSensorsData({
      site: activeSite,
      date: activeDate.utc().format('YYYY-MM-DD'),
    })
  }

  shouldComponentUpdate(nextProps) {
    const { activeSite, activeDate, fetchSensorsData } = this.props
    const { activeSite: nextActiveSite, activeDate: nextActiveDate } = nextProps

    if (activeSite !== nextActiveSite || activeDate !== nextActiveDate) {
      fetchSensorsData({
        site: nextActiveSite,
        date: nextActiveDate.utc().format('YYYY-MM-DD'),
      })

      return false
    }

    return true
  }

  getTooltipContent = (depth, param, value, time) => {
    const {
      intl: { formatMessage },
    } = this.props

    return (
      <>
        <div>{depth}</div>
        <div>
          {param}: {value}
        </div>
        <div>
          {formatMessage(messages.lastUpdate)}:{' '}
          {value !== '--' ? time : '--:--'}
        </div>
      </>
    )
  }

  render() {
    const {
      intl: { formatMessage },
      licensee,
    } = this.props
    const sensors = this.props.sensorsData.toJS()

    return (
      <Table aria-label="simple table" className="env-table">
        <TableHead>
          <TableRow>
            <TableCell align="left" className="env-table-cell">
              {' '}
            </TableCell>
            <TableCell align="center" className="env-table-cell">
              5m
            </TableCell>
            <TableCell align="center" className="env-table-cell">
              5m avg
            </TableCell>
            <TableCell align="center" className="env-table-cell">
              10m
            </TableCell>
            <TableCell align="center" className="env-table-cell">
              10m avg
            </TableCell>
            <TableCell align="center" className="env-table-cell">
              15m
            </TableCell>
            <TableCell align="center" className="env-table-cell">
              15m avg
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(sensors).map((key, index) => {
            const sensor = sensors[key]
            const label = formatMessage(messages[`sensor_${key}`])
            let digits

            switch (key) {
              case TYPE_SATURATION:
                digits = 0
                break
              case TYPE_OXYGEN:
              case TYPE_TEMPERATURE:
              case TYPE_SPEED:
                digits = 1
                break
              default:
                digits = 2
            }

            const value5 = sensor['5'].value
              ? licenseeDigitFormat(
                  toFixed(sensor['5'].value, digits),
                  licensee,
                )
              : '--'
            const value5avg = sensor['5avg']
              ? licenseeDigitFormat(toFixed(sensor['5avg'], digits), digits)
              : '--'
            const value10 = sensor['10'].value
              ? licenseeDigitFormat(toFixed(sensor['10'].value, digits), digits)
              : '--'
            const value10avg = sensor['10avg']
              ? licenseeDigitFormat(toFixed(sensor['10avg'], digits), digits)
              : '--'
            const value15 = sensor['15'].value
              ? licenseeDigitFormat(toFixed(sensor['15'].value, digits), digits)
              : '--'
            const value15avg = sensor['15avg']
              ? licenseeDigitFormat(toFixed(sensor['15avg'], digits), digits)
              : '--'

            return (
              <TableRow key={index} data-index={key}>
                <TableCell align="left" className="env-table-cell">
                  {label}
                </TableCell>
                <TableCell align="center" className="env-table-cell">
                  <Tooltip
                    title={this.getTooltipContent(
                      '5m',
                      label,
                      value5,
                      sensor['5'].time,
                    )}>
                    <span className="environment-cell">{value5}</span>
                  </Tooltip>
                </TableCell>
                <TableCell align="center" className="env-table-cell">
                  <Tooltip
                    title={this.getTooltipContent(
                      '5m avg',
                      label,
                      value5avg,
                      sensor['5'].time,
                    )}>
                    <span className="environment-cell">{value5avg}</span>
                  </Tooltip>
                </TableCell>
                <TableCell align="center" className="env-table-cell">
                  <Tooltip
                    title={this.getTooltipContent(
                      '10m',
                      label,
                      value10,
                      sensor['10'].time,
                    )}>
                    <span className="environment-cell">{value10}</span>
                  </Tooltip>
                </TableCell>
                <TableCell align="center" className="env-table-cell">
                  <Tooltip
                    title={this.getTooltipContent(
                      '10m avg',
                      label,
                      value10avg,
                      sensor['10'].time,
                    )}>
                    <span className="environment-cell">{value10avg}</span>
                  </Tooltip>
                </TableCell>
                <TableCell align="center" className="env-table-cell">
                  <Tooltip
                    title={this.getTooltipContent(
                      '15m',
                      label,
                      value15,
                      sensor['15'].time,
                    )}>
                    <span className="environment-cell">{value15}</span>
                  </Tooltip>
                </TableCell>
                <TableCell align="center" className="env-table-cell">
                  <Tooltip
                    title={this.getTooltipContent(
                      '15m avg',
                      label,
                      value15avg,
                      sensor['15'].time,
                    )}>
                    <span className="environment-cell">{value15avg}</span>
                  </Tooltip>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    activeDate: state.getIn(['slaMonitor', 'activeDate']),
    module: state.getIn(['environment', 'module']),
    sensorsData: state.getIn(['environment', 'sensorsData']),
    licensee: state.getIn(['profile', 'profile', 'licensee']),
  }),
  {
    setEnvironmentModule,
    fetchSensorsData,
  },
)(injectIntl(ModuleB))
